const FontSizes = {
  headerSize: 500,
  standardSize: 400,
  subtextSize: 300,
}

export default FontSizes
